export function Section({ title, eyebrow, description, children, className = '' }) {
  return (
    <section className={`section shell ${className}`.trim()}>
      {(eyebrow || title || description) && (
        <div className="section__intro">
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          {title ? <h2 className="section__title">{title}</h2> : null}
          {description ? <p className="section__description">{description}</p> : null}
        </div>
      )}
      {children}
    </section>
  );
}